<app-region-selector></app-region-selector>
@if (isRedirecting) {
	<loading></loading>
} @else if (!showRegionSelector) {
	<signup-view-instructor
		[isDashboard]="true"
		[courseInvite]="courseInvite"
		(navigated)="navigate($event)"
		[infoKey]="infoKey"
		[mode]="modes.EDUCATION">
	</signup-view-instructor>
}
